export const changeCSS = (cssFile, themeLinkId)=> {
    const oldLink = document.getElementById(themeLinkId);
    if (!oldLink) return;
    const newLink = document.createElement('link');
    newLink.setAttribute('rel', 'stylesheet');
    newLink.setAttribute('id', themeLinkId);
    newLink.setAttribute('type', 'text/css');
    newLink.setAttribute('href', cssFile);

    document
      .getElementsByTagName('head')
      .item(0)
      .replaceChild(newLink, oldLink);
  }
